import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, concat, Subject } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';

import { RfqService } from '@app/core/quotes';
import { UIStateService } from '@app/shared/services/ui-state.service';

@Component({
  selector: 'cnc-update-master-alternate-sku',
  templateUrl: './update-master-alternate-sku.component.html',
  styleUrls: ['./update-master-alternate-sku.component.scss'],
})
export class UpdateMasterAlternateSkuComponent implements OnInit {
  initialize :boolean = false;
  filter :any = {};

  formData :UntypedFormGroup;
  pageTitle :string = 'Update SKU Master Alternate SKUs';
  submitted :boolean = false;
  loading :boolean = false;
  searchKey :string = '';

  @Input() rfq :any;
  alternateSKUs :any[] = [];
  alternate_master_sku :string = '';

  checked :any = [];
  showFilter :boolean = false;
  checkedAll :boolean = false;
  checkedCount :number = 0;

  SKUs :any[] = [];

  rfq$ :Observable<any[]>;
  rfqLoading = false;
  rfqInput$ = new Subject<string>();

  params :any = {
    per_page: 200,
    page: 1,
  };

  record :any = [];

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    private uiStateSvc :UIStateService,
    private toastr :ToastrService,
    public rfqSvc :RfqService,
  ) {}

  ngOnInit() {
    this.initialize = false;
    this.getChildSKU(this.rfq.id);

    this.formData = this.fb.group({
      transfer_type: [null, [Validators.required]],
      locations: [null, [Validators.required]],
      rfq: [null, [Validators.required]],
      previous_locations: this.fb.array([]),
    });
    this.loadRfqs();

    // this.alternateSKUs = this.rfq.alternate_skus;
  }

  countChecked() {
    this.checkedCount = this.checked.filter((x) => {
      return x;
    }).length;
  }

  checkAll() {
    this.rfqSvc.record$.subscribe((records) => {
      records.data.forEach((r) => {
        this.checked[r.id] = this.checkedAll;
      });
      this.countChecked();
    });
  }

  searchRecords(e) {
    this.filter.keyword = e.target.value;
    this.params.page = 0;

    if (this.searchKey && this.searchKey.trim().length > 0) {
      this.params.keyword = this.searchKey;
    } else {
      delete this.params.keyword;
    }

    this.params = Object.assign(this.params, this.filter);

    this.rfqSvc.setParams(this.params);
    this.rfqSvc.refreshList();
  }

  attachSKU() {
    if (this.loading || this.alternate_master_sku.trim() == '') {
      return;
    }
    console.log(this.alternate_master_sku);
    console.log(this.rfq.id);
    if (this.alternate_master_sku != this.rfq.internal_sku) {
      this.loading = true;
      const data = {
        rfq_id: this.rfq.id,
        sku: this.rfq.internal_sku,
        alternate_sku: this.alternate_master_sku,
      };

      this.rfqSvc.attachChildSku(this.rfq.id, data).subscribe(
        (resp) => {
          this.toastr.success('Added.');
          this.alternate_master_sku = '';
          this.loading = false;
          this.getChildSKU(this.rfq.id);
        },
        (err) => {
          this.toastr.error('Error!', err.error.error);
          this.loading = false;
        },
      );
    }
  }

  getChildSKU(rfqId) {
    this.rfqSvc.getChildSKU(rfqId).subscribe((res) => {
      this.rfq.childSku = res;
    });
  }

  detachAlternateSku(idx) {
    const data = {
      rfq_id: this.rfq.id,
      sku: this.rfq.internal_sku,
      alternate_sku: this.rfq.childSku[idx].internal_sku,
    };
    this.rfqSvc.detachChildSku(data).subscribe((resp) => {
      this.toastr.success('Detached.');
    });
    this.getChildSKU(this.rfq.id);
  }

  private loadRfqs() {
    this.rfq$ = concat(
      of([]), // default items
      this.rfqInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.rfqLoading = true)),
        switchMap((term) =>
          this.rfqSvc
            .getAsync({ sku: term, is_discontinued: 2, id: this.rfq.id })
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => (this.rfqLoading = false)),
              map((resp) => resp.data),
            ),
        ),
      ),
    );
  }
}
